/** Adding the app to a phone's home screen. Chrome and Edge on Android tell the page when it can be installed (once, early), so that is kept here until a button asks for it; iPhones have no such thing and need the Share-menu steps. */
let deferred = null;

export function initInstall() {
  window.addEventListener("beforeinstallprompt", (e) => { e.preventDefault(); deferred = e; window.dispatchEvent(new Event("hp-install-ready")); });
  window.addEventListener("appinstalled", () => { deferred = null; window.dispatchEvent(new Event("hp-installed")); });
}

export const canPromptInstall = () => !!deferred;
export const isStandaloneApp = () => (window.matchMedia && window.matchMedia("(display-mode: standalone)").matches) || window.navigator.standalone === true;
export const onIOS = () => /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
export const iosNotSafari = () => onIOS() && /CriOS|FxiOS|EdgiOS|OPiOS|GSA\//.test(navigator.userAgent);       // Chrome, Firefox and others on iPhone can't add to the Home Screen the way Safari does

/** Shows the browser's own install box. Resolves true if the person accepted. */
export async function promptInstall() {
  if (!deferred) return false;
  const ev = deferred; deferred = null;
  ev.prompt();
  try { const r = await ev.userChoice; return r.outcome === "accepted"; } catch { return false; }
}
